import { render, staticRenderFns } from "./WholeTransAnalysis.vue?vue&type=template&id=4c6f5cee&scoped=true"
import script from "./WholeTransAnalysis.vue?vue&type=script&lang=js"
export * from "./WholeTransAnalysis.vue?vue&type=script&lang=js"
import style0 from "./WholeTransAnalysis.vue?vue&type=style&index=0&id=4c6f5cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f5cee",
  null
  
)

export default component.exports